export const FAQ_ROUTES = {
  index: '/workspace/:workspaceSlug/faqs',
  create: '/workspace/:workspaceSlug/faqs/new',
  edit: '/workspace/:workspaceSlug/faqs/:itemId/edit',
  portal: '/portal/:slug/knowledge/faqs'
};
